<template>


    <v-card class="bg-card mb-2">
        <v-card-text class="px-0 pt-0 pb-0">
            <v-tabs dense v-model="tab">        
                <v-tab>Werkbon documenten ({{ (model.attachmentsWorkorder||[]).length }})</v-tab>                
                <v-tab>Buitendienst foto's ({{ (model.attachmentsAppointment||[]).length }})</v-tab>                
            </v-tabs>

        <v-tabs-items class="workorder-tabs mt-0" v-model="tab">                
            <v-tab-item class="attachments-workorder" transition="none" reverse-transition="none">                        
                <AttachmentsWorkorder :model="model"></AttachmentsWorkorder>
            </v-tab-item>
            <v-tab-item class="attachments-appointments" transition="none" reverse-transition="none">                        
                <AttachmentsAppointment :model="model"></AttachmentsAppointment>
            </v-tab-item>
        </v-tabs-items>
        </v-card-text>
    </v-card>

</template>



<script setup>

import {ref} from 'vue'

import dlg from '@app/dlg'
import AttachmentsAppointment from './AttachmentsAppointment.vue'
import AttachmentsWorkorder from './AttachmentsWorkorder.vue'

const tab = ref(0);

const props = defineProps({
    model: {
        type: [Object]
    },
});

</script>